












































import Vue from "vue";
import { required } from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import {
  DeliveryRawStatusForm,
  RawStatus
} from "../forms/DeliveryRawStatusForm";
import DeliveryRawStatusTableBody from "../components/DeliveryRawStatusTableBody.vue";
export default Vue.extend({
  mixins: [dialog],
  components: {
    DeliveryRawStatusTableBody
  },
  validations: {
    deliveryRawStatusForm: {
      status: {
        $each: {
          name: { required },
          status: { required }
        }
      }
    }
  },
  data() {
    const loading = false;
    const isUpdate = false;
    const deliveryRawStatusForm: DeliveryRawStatusForm = {
      deliveryId: 0,
      status: []
    };
    return { loading, isUpdate, deliveryRawStatusForm };
  },
  async created() {
    await this.getRawStatus(+this.$route.params.id);
  },
  methods: {
    async getRawStatus(deliveryId: number) {
      this.loading = true;
      try {
        const {
          data
        } = await (this as any).$dep.deliveryModeUseCase.getDeliveryRawStatusByDeliveryId(
          deliveryId
        );

        this.deliveryRawStatusForm = {
          deliveryId: data.id,
          status: data.jsonRawStatus
        };

        this.isUpdate = true;
      } catch (error) {
        this.isUpdate = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async createRawStatus() {
      this.loading = true;

      try {
        await (this as any).$dep.deliveryModeUseCase.createDeliveryRawStatusMapping(
          this.deliveryRawStatusForm
        );

        if (await (this as any).alertSuccess("Success", "อัพเดตข้อมูลสำเร็จ")) {
          this.gotoDeliveryMappingList();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          (this as any).alertError("Error", error);
        }
      } finally {
        this.loading = false;
      }
    },
    async updateRawStatus() {
      this.loading = true;

      try {
        await (this as any).$dep.deliveryModeUseCase.updateDeliveryRawStatusMapping(
          this.deliveryRawStatusForm
        );

        if (await (this as any).alertSuccess("Success", "อัพเดตข้อมูลสำเร็จ")) {
          this.gotoDeliveryMappingList();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          (this as any).alertError("Error", error);
        }
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.deliveryRawStatusForm.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "ยืนยันการใส่ค่า Raw Status",
        "คุณต้องการแก้ไขข้อมูลหรือไม่ ?"
      );
      if (isConfirmed) {
        await this.saveRawStatus();
      }
    },
    async saveRawStatus() {
      if (this.isUpdate) {
        await this.updateRawStatus();
      } else {
        this.deliveryRawStatusForm = {
          ...this.deliveryRawStatusForm,
          deliveryId: +this.$route.params.id
        };
        await this.createRawStatus();
      }
    },

    removeRow(index: number) {
      const statuses = this.deliveryRawStatusForm.status.filter((_, i) => {
        return i !== index;
      });

      this.deliveryRawStatusForm = {
        ...this.deliveryRawStatusForm,
        status: statuses
      };
    },

    addStatusRow() {
      this.deliveryRawStatusForm = {
        ...this.deliveryRawStatusForm,
        status: [...this.deliveryRawStatusForm.status, { status: "", name: "" }]
      };
    },

    gotoDeliveryMappingList() {
      this.$router.push({ name: "DeliveryMappingList" });
    },

    updateStatus(e: RawStatus, index: number) {
      this.deliveryRawStatusForm = {
        ...this.deliveryRawStatusForm,
        status: this.deliveryRawStatusForm.status.map((item: RawStatus, i) => {
          return i == index ? e : item;
        })
      };
    }
  }
});
